import { combineReducers } from 'redux'

import devicesList from './devicesList'
import snapshot from './snapshot'

export default combineReducers({
  devicesList,
  snapshot,
})
